import './card.scss';
import Component from '../component/component';

export default class Card extends Component {
    static initSelector: string = '.card';

    constructor(target: HTMLElement) {
        super(target);

        this.init();
    }

    init(): void {
        this.addUnderline();
    }

    public addUnderline(): void {
        const cardLink: JQuery<HTMLElement> = this.element.find('.card__link');
        const readMore: JQuery<HTMLElement> = this.element.find('.read-more');

        cardLink.on('mouseover', (): void => {
            readMore.addClass(' is-hovered');
        });

        cardLink.on('mouseout', (): void=> {
            readMore.removeClass(' is-hovered');
        });
    }
}
